import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Taxaties {
    constructor() {
        if (document.querySelector('#show.taxaties') !== null) {
            this.initTaxatieSlider();
        }
    }

    initTaxatieSlider() {
        new Swiper('#taxatie-table .swiper-container', {
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                }
            }
        });
    }
}
